const ICON_NAMES = {
  X: 'x',
  DISCOUNTS: 'discounts',
  USER: 'user',
  STARS: 'stars',
  PEOPLE_IN_HOME: 'peopleInHome',
  PEOPLE: 'people',
  TREASURE: 'treasure',
  DOOR: 'door',
  INCIDENTS: 'incidents',
  HISTORY: 'history',
  VEHICLES: 'vehicles',
  ID: 'id',
  ID_FOLDER: 'idFolder',
  ASSIGN_DRIVERS: 'assignDrivers',
  POLICE: 'police',
  FIRE_DEPT: 'firedept',
  OPERATOR: 'operator',
  ALARM: 'alarm',
  AUTO: 'auto',
  HOME: 'home',
  RENTERS: 'renters',
  BUNDLED: 'bundled',
  PHONE: 'phone',
  ONLINE: 'online',
  QUESTION: 'question',
  HOME_PHONE: 'homePhone',
  CELL_PHONE: 'cellPhone',
  WORK_PHONE: 'workPhone',
  PRICE: 'price',
  GREAT_COVERAGE: 'greatCoverage',
  SCALES: 'scales',
  DUNNO: 'dunno',
  GREATBRAND: 'greatBrand',
  PIGGY: 'piggy',
  CONVERSATION: 'conversation',
  ROWHOME: 'rowhome',
  MULTIFAMILY: 'multifamily',
  MOBILEHOME: 'mobilehome',
  SINGLEFAMILY: 'singlefamily',
  APARTMENT: 'apartment',
  COOP: 'coop',
  CREDIT_CARD: 'creditCard',
  LOAN: 'loan',
  BANK_TRANSFER: 'bankTransfer',
  EMAIL: 'email',
  EMAIL_PHONE: 'emailPhone',
  SPRINKLER: 'sprinkler',
  SMOKE_DETECTOR: 'smokeDetector',
  DEADBOLT: 'deadbolt',
  FIRE_EXTINGUISHER: 'fireExtinguisher',
  NO_SMOKING: 'noSmoking',
  RECEPTIONIST: 'receptionist',
  UMBRELLA: 'umbrella',
  CONDO: 'condo'
};

module.exports = {
  ICON_NAMES
};
